import { BellRingingIcon } from "@phosphor-icons/react";

import { NotificationsPage } from "@/client/services/notification";

/**
 * Page Notifications de l'espace utilisateur.
 *
 * Enveloppe premium autour du centre de notifications (filtres par
 * catégorie, groupement par jour, temps réel, opt-in push) dont les
 * composants partagent déjà le design system (tokens text-muted,
 * canvas-subtle, surfaces douces).
 */
export const UserSpaceNotificationsPage = () => (
  <div className="mx-auto w-full max-w-[1240px] px-4 pb-24 pt-6 sm:px-6 lg:pb-6">
    <header className="mb-5">
      <div className="flex items-start gap-3">
        <span className="mt-0.5 hidden size-10 shrink-0 place-items-center rounded-xl bg-indigo-50 text-indigo-600 sm:grid">
          <BellRingingIcon aria-hidden size={22} weight="duotone" />
        </span>
        <div>
          <h1 className="text-xl font-bold tracking-tight text-indigo-950 sm:text-2xl">
            Notifications
          </h1>
          <p className="mt-1 max-w-2xl text-xs leading-5 text-slate-500 sm:text-[13px]">
            Toute l'activité de votre compte : paiements, crédits IA, parrainage et sécurité.
          </p>
        </div>
      </div>
    </header>

    <NotificationsPage />
  </div>
);
